import styled from 'styled-components';

export const SliderContainer = styled.section`
  width: 100%;
  margin-bottom: 45px;
  border-bottom: 2px solid ${({ theme }) => theme.lightGray};
  
  overflow: hidden;
  
  .swiper-container {
    width: 100%;
    margin: 0 auto;
    padding: 30px 0;
    padding-bottom: 40px;
  }
  
  .swiper-slide {
    height: auto;
  }
  
  .swiper-pagination {
    bottom: 10px;
  }
  
  .swiper-pagination-bullet {
    width: 10px;
    height: 10px;
    background: transparent;
    border: 2px solid #e8e8e8;
    opacity: 1;
    
    transition: border-color 0.3s, background-color 0.3s;
    
    &-active {
      border-color: ${({ theme }) => theme.blue};
      background-color: ${({ theme }) => theme.blue};
    }
  }
  
  @media(min-width: 700px) {
    .swiper-pagination {
      display: none;
    }
    
    .swiper-wrapper {
      transform: none !important;
      display: flex;
      justify-content: center;
    }
  }
`;

export const SliderItem = styled.article`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
`;
